import * as React from 'react';
import * as I18n from 'i18n-js';

import { categoryForSlug } from './category_data';
import URLHelpers from '../shared/url_helpers';

import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import Tiles from '@reverbdotcom/commons/dist/components/tiles';
import OverflowingRow from '@reverbdotcom/commons/dist/components/overflowing_row';
import { trackView, CATEGORY_TYPE } from '@reverbdotcom/commons/dist/tracker';

const categoryList = [
  'electric-guitars',
  'keyboards-and-synths',
  'acoustic-guitars',
  'amps',
  'effects-and-pedals',
  'drums-and-percussion',
  'bass-guitars',
  'pro-audio',
  'dj-and-lighting-gear',
  'folk-instruments',
  'band-and-orchestra',
  'software',
  'home-audio',
  'parts',
  'accessories',
].map(categoryForSlug);

function Category({ category, position }) {
  if (!category) { return null; }

  return (
    <CoreLink
      to={URLHelpers.categoryPagePath(category.slug)}
      trackName="CategoriesRow"
      trackEntityType="category"
      trackEntityId={category.uuid}
      trackPosition={position}
      className="category-item category-item--v2"
    >
      <div
        className="category-item__image"
        style={{ backgroundImage: `url(${category.image_v2})` }}
      />
      <div className="category-item__footer">
        <div className="category-item__text">
          {I18n.t(`discovery.taxonomy.${category.uuid}`)}
        </div>
      </div>
    </CoreLink>
  );
}

export default function HomepageCategoriesV2({ noTitle = false }) {
  React.useEffect(() => {
    trackView({
      componentName: 'CategoriesRow',
      type: CATEGORY_TYPE,
      ids: categoryList.map(cat => cat.uuid),
    });
  }, []);

  const title = noTitle ? null : I18n.t('discovery.homepage.categories.heading');

  return (
    <section className="scaling-mb-7">
      <OverflowingRow
        title={title}
      >
        <Tiles
          loading={false}
          expectedCount={categoryList.length}
          singleRow
          largeTiles
        >
          {categoryList.map((category, i) => {
            return (
              <Category
                key={category.uuid}
                category={category}
                position={i}
              />
            );
          })}
        </Tiles>
      </OverflowingRow>
    </section>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage_categories_v2.tsx